export default __webpack_public_path__ + "static/media/Info.a3667e64.svg";